'use es6';

export const MSG_TYPE_MODAL_DIALOG_CLOSE = 'MODAL_DIALOG_CLOSE';